import ownerDocument from 'dom-helpers/ownerDocument';
import safeFindDOMNode from './safeFindDOMNode';
export default (function (componentOrElement) {
  return ownerDocument(safeFindDOMNode(componentOrElement));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-overlays/esm/ownerDocument.js
// module id = 781
// module chunks = 0